// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__awWVG","main":"Layout_main__kn-zz"};